var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('InputCode',_vm._b({attrs:{"value":_vm.buffer,"language":"json","options":_vm.currentOptions,"autofocus":"","is-invalid":!_vm.jsonIsValid},on:{"input":_vm.onChange}},'InputCode',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }